import {
  Component,
  EventEmitter,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import * as fromHome from '../../state';
import * as fromRoot from '../../../state';
import * as homeAction from '../../state/actions/post.action';
import { HomeActionTypes } from '../../state/actions/post.action';
import { Store } from '@ngrx/store';
import { PostFormState } from '../../state/states/post-form.state';
import { NewPostState } from '../../state/states/new-post.state';
import { Observable, Subject } from 'rxjs';
import { HomeEffects } from '../../state/effects/home.effects';
import { Router } from '@angular/router';
import uid from 'uid';
import { Actions, ofType } from '@ngrx/effects';
import { map, skipWhile, takeUntil } from 'rxjs/operators';
import { NotificationService } from '../../../core/core.module';
import * as Moment from 'moment';
import { QuillEditorComponent } from 'ngx-quill';
import { MarkdownService } from '../../../markdown/markdown.service';
import { NewPostMutationInput } from '../../../shared/data/inputs/new-post-mutation.input';
import {
  initialUploadModel,
  UploadFileModel
} from '../../../shared/data/models/upload-file.model';
import { MiniUserModel } from '../../../shared/data/models/mini-user.model';
import { CreatePostValidator } from '../../../global/varidators/create-post.validator';
import { Cloudinary } from '@cloudinary/angular-5.x';
import {
  FileUploader,
  FileUploaderOptions,
  ParsedResponseHeaders
} from 'ng2-file-upload';
import { FileUploadModel } from '../../../shared/file-upload.model';

interface MyPeriod {
  value: number;
  viewValue: number;
}

interface Category {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'main-create-post',
  templateUrl: './create-post.component.html',
  styleUrls: ['./create-post.component.scss']
})
export class CreatePostComponent implements OnInit, OnDestroy {
  @Output() postInput = new EventEmitter<NewPostMutationInput>();

  categories: Category[] = [
    { value: 'cat-0', viewValue: 'Nature' },
    { value: 'cat-1', viewValue: 'Politics' },
    { value: 'cat-2', viewValue: 'Entertainment' }
  ];

  isAuthenticated$: Observable<boolean>;

  @ViewChild('quillEditor') editor: QuillEditorComponent;

  postFormGroup: FormGroup;

  newPostState$: Observable<NewPostState>;

  days: MyPeriod[] = [...Array(4).keys()].map(v => {
    return { value: v, viewValue: v } as MyPeriod;
  });

  hours: MyPeriod[] = [...Array(25).keys()].map(v => {
    return { value: v, viewValue: v } as MyPeriod;
  });

  minutes: MyPeriod[] = [...Array(61).keys()]
    .map(v => {
      return { value: v, viewValue: v } as MyPeriod;
    })
    .filter(v => v.value % 5 === 0);

  postFormType: 'POST' | 'POLL' | 'ARTICLE';
  postFormState$: Observable<PostFormState>;
  uploadingFiles: UploadFileModel[];

  currentUser: MiniUserModel;

  answers: FormArray = new FormArray([]);

  unsubscribed$ = new Subject();
  me$: Observable<MiniUserModel>;

  uploader: FileUploader;

  title = '';
  responses: Array<any>;
  uploadingVideos$: Observable<FileUploadModel[]>;

  constructor(
    private myStore: Store<fromRoot.State>,
    private formBuilder: FormBuilder,
    private store$: Store<fromHome.State>,
    private actions$: Actions,
    private homeEffect: HomeEffects,
    private router: Router,
    private notificationService: NotificationService,
    private markdownService: MarkdownService,
    private cloudinary: Cloudinary,
    private zone: NgZone
  ) {
    this.responses = [];
    this.postFormGroup = this.createPostForm();
  }

  static createArticlePost(formData: {
    title?: string;
    body?: string;
  }): NewPostMutationInput {
    return {
      title: formData.title,
      body: formData.body,
      postType: 'ARTICLE'
    };
  }

  ngOnInit(): void {
    this.newPostState$ = this.store$.select(fromHome.getNewPostState);

    this.me$ = this.store$.select(fromRoot.getMe);

    // Create the file uploader, wire it to upload to your account
    const uploaderOptions: FileUploaderOptions = {
      url: `https://api.cloudinary.com/v1_1/${
        this.cloudinary.config().cloud_name
      }/upload`,
      // Upload files automatically upon addition to upload queue
      autoUpload: true,
      // Use xhrTransport in favor of iframeTransport
      isHTML5: true,
      // Calculate progress independently for each uploaded file
      removeAfterUpload: true,

      // max file size
      maxFileSize: 50 * 1024 * 1024,
      // XHR request headers
      headers: [
        {
          name: 'X-Requested-With',
          value: 'XMLHttpRequest'
        }
      ]
    };

    this.uploader = new FileUploader(uploaderOptions);
    this.uploader.onBuildItemForm = (fileItem: any, form: FormData): any => {
      // Add Cloudinary's unsigned upload preset to the upload form
      form.append('upload_preset', this.cloudinary.config().upload_preset);
      // Add built-in and custom tags for displaying the uploaded photo in the list
      let tags = 'video';
      if (this.title) {
        form.append('context', `photo=${this.title}`);
        tags = `gscroll,${this.title}`;
      }
      // Upload to a custom folder
      // Note that by default, when uploading via the API, folders are not automatically created in your Media Library.
      // In order to automatically create the folders based on the API requests,
      // please go to your account upload settings and set the 'Auto-create folders' option to enabled.
      form.append('folder', 'gscroll-videos');
      // Add custom tags
      form.append('tags', tags);
      // Add file to upload
      form.append('file', fileItem);

      // Use default "withCredentials" value for CORS requests
      fileItem.withCredentials = false;
      return { fileItem, form };
    };

    // Insert or update an entry in the responses array
    const upsertResponse = fileItem => {
      // Run the update in a custom zone since for some reason change detection isn't performed
      // as part of the XHR request to upload the files.
      // Running in a custom zone forces change detection
      this.store$.dispatch(new homeAction.AddVideoUploadFile(fileItem));
      // this.zone.run(() => {
      //   // Update an existing entry if it's upload hasn't completed yet
      //   console.log(fileItem);
      //   // Find the id of an existing item
      //   const existingId = this.responses?.reduce((prev, current, index) => {
      //     if (current.file.name === fileItem.file.name && !current.status) {
      //       return index;
      //     }
      //     return prev;
      //   }, -1);
      //   if (existingId > -1) {
      //     // Update existing item with new data
      //     this.responses[existingId] = Object.assign(
      //       this.responses[existingId],
      //       fileItem
      //     );
      //   } else {
      //     // Create new response
      //     this.responses.push(fileItem);
      //   }
      // });
    };

    // Update model on completion of uploading a file
    this.uploader.onCompleteItem = (
      item: any,
      response: string,
      status: number,
      headers: ParsedResponseHeaders
    ) =>
      upsertResponse({
        file: item.file,
        status,
        data: JSON.parse(response)
      });

    // Update model on upload progress event
    this.uploader.onProgressItem = (fileItem: any, progress: any) =>
      upsertResponse({
        file: fileItem.file,
        progress,
        data: {}
      });

    // this.uploader.onErrorItem = (fileItem: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
    //   console.error('xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx');
    // };

    this.uploader.onWhenAddingFileFailed = this.uploader.onWhenAddingFileFailed = (
      item,
      filter
    ) => {
      let message = '';
      switch (filter.name) {
        case 'fileSize':
          message = 'The video should be less than 50mb';
          break;
        default:
          message = 'Error trying to upload file ' + item?.name;
          break;
      }

      this.notificationService.error(message);
    };

    this.store$
      .select(fromRoot.getMe)
      .pipe(takeUntil(this.unsubscribed$))
      .subscribe(user => {
        this.currentUser = user;
      });

    this.postFormState$ = this.store$.select(fromHome.getPostFormState);
    this.store$
      .select(fromHome.getUploadingImages)
      .pipe(takeUntil(this.unsubscribed$))
      .subscribe(upload => {
        this.uploadingFiles = upload;
      });

    this.uploadingVideos$ = this.store$.select(fromHome.getUploadingVideos);

    this.store$.select(fromHome.getPostFormType).subscribe(formType => {
      // reset form and start a fresh
      this.postFormType = formType;

      switch (formType) {
        case 'ARTICLE':
          this.setArticleValidators();
          break;

        case 'POLL':
          this.postFormGroup.reset();
          this.usePoll();
          break;

        case 'POST':
          this.setPostValidators();
          break;
      }
    });

    this.actions$
      .pipe(
        ofType<homeAction.CreateNormalPostSuccess>(
          HomeActionTypes.CreateNormalPostSuccess
        ),
        map(action => action.payload),
        skipWhile(p => !p)
      )
      .subscribe(_ => {
        this.postFormGroup.reset();
        this.postFormGroup?.get('articleBody')?.setValue(' ');

        // change to normal post
        this.createPost();
      });

    this.isAuthenticated$ = this.myStore.select(fromRoot.getIsAuthenticated);
  }

  private createPostForm(): FormGroup {
    return this.formBuilder.group({
      title: [''],
      body: [''],
      articleBody: [''],

      dayDuration: [''],
      hourDuration: [''],
      minuteDuration: [''],

      question: [''],
      answers: this.answers
    });
  }

  createNewPost(): void {
    if (this.postFormGroup.invalid) {
      this.postFormGroup.markAllAsTouched();
      return;
    }

    const formData: {
      body?: string;
      articleBody?: string;
      title?: string;
      question?: string;
      answers?: string[];
      expiry?: number;
      dayDuration: number;
      hourDuration: number;
      minuteDuration: number;
    } = this.postFormGroup.getRawValue();

    // check if all images are uploaded
    let allUploaded = true;
    this.uploadingFiles.forEach(v => {
      if (v.loading) {
        allUploaded = false;
      }
    });

    if (!allUploaded) {
      this.notificationService.warn(
        'Not all files have been uploaded, please wait'
      );
      return;
    }

    if (this.postFormGroup.valid) {
      let inputs: NewPostMutationInput = null;

      if (this.postFormType === 'POST') {
        inputs = this.createNormalPost(this.postFormGroup.getRawValue());
      }

      if (this.postFormType === 'ARTICLE') {
        inputs = CreatePostComponent.createArticlePost({
          body: this.markdownService.convert(formData?.articleBody),
          title: formData?.title
        });
      }

      if (this.currentUser) {
        if (this.postFormType !== 'POLL') {
          this.postInput.emit(inputs);
        } else {
          let minutes = 0;

          if (formData.hourDuration > 0) {
            minutes += formData.hourDuration * 60;
          }

          if (formData.minuteDuration > 0) {
            minutes += formData.minuteDuration;
          }

          if (formData.dayDuration > 0) {
            minutes += formData.dayDuration * 1440;
          }

          if (minutes === 0) {
            this.notificationService.error('The poll duration is too short');
            return;
          }

          const expireDate = Moment()
            .add(minutes, 'minutes')
            .utc()
            .toISOString();

          const pollInput: NewPostMutationInput = {
            postType: 'POLL',
            pollData: {
              question: formData.question,
              answers: formData.answers,
              expiry: expireDate
            },
            body: ' '
          };
          this.postInput.emit(pollInput);
        }
      } else {
        this.router.navigateByUrl('/auth/login');
      }
    }
  }

  createPoll(): void {
    this.store$.dispatch(new homeAction.PollFormType());
  }

  createArticle(): void {
    const writtenPost = this.postFormGroup?.get('body')?.value;

    if (writtenPost) {
      this.postFormGroup?.get('articleBody')?.setValue(writtenPost);
    }

    this.store$.dispatch(new homeAction.ArticleFormType());
  }

  createPost(): void {
    this.store$.dispatch(new homeAction.PostFormType());
  }

  createNormalPost(formData: {
    title?: string;
    body?: string;
  }): NewPostMutationInput {
    return {
      body: this.markdownService.convert(formData.body),
      postType: 'POST'
    };
  }

  setPostValidators(): void {
    this.postFormGroup.get('body').setValidators([Validators.required]);

    this.postFormGroup
      .get('body')
      .setAsyncValidators([
        CreatePostValidator.minPost(this.markdownService, 5),
        CreatePostValidator.maxPost(this.markdownService, 280)
      ]);

    this.postFormGroup.get('title').setValidators(null);
    this.postFormGroup.get('title').setErrors(null);
    this.postFormGroup.get('articleBody').setValidators(null);
    this.postFormGroup.get('articleBody').clearAsyncValidators();
    this.postFormGroup.get('articleBody').setErrors(null);

    this.clearPollFieldValidators();
    this.clearAnswerControls();
  }

  onFileSelect(filex: any): void {
    if (filex.target.files && filex.target.files[0]) {
      const fileData: File = filex.target.files[0];

      const reader = new FileReader();

      reader.readAsDataURL(fileData);

      const fileName = `${this.currentUser.handle}_${uid(
        5
      )}.${fileData.name.split('.').pop()}`;

      reader.onload = (e: any) => {
        this.store$.dispatch(
          new homeAction.AddUploadFile({
            ...initialUploadModel,
            fileName: fileName,
            file: fileData,
            path: e.target.result
          })
        );
      };

      this.store$.dispatch(
        new homeAction.UploadFile({
          input: {
            resource: 'POSTS',
            fileName: fileName,
            resourceID: ''
          },
          file: fileData
        })
      );
    }
  }

  removeImage(fileIndex: number): void {
    this.store$.dispatch(new homeAction.RemoveUploadFile(+fileIndex));
  }

  removeUploadVideo(file: FileUploadModel): void {
    this.store$.dispatch(new homeAction.RemoveVideoUploadFile(file.file.name));
    // this.uploader.cancelItem()
  }

  // will add extra fields
  addOptionalAnswer(): void {
    this.answers.push(new FormControl(''));
  }

  private setArticleValidators(): void {
    this.postFormGroup.get('body').setValidators(null);
    this.postFormGroup.get('body').setErrors(null);
    this.postFormGroup.get('body').clearAsyncValidators();

    this.postFormGroup.get('articleBody').setValidators([Validators.required]);

    this.postFormGroup
      .get('articleBody')
      .setAsyncValidators([
        CreatePostValidator.minPost(this.markdownService, 280)
      ]);

    this.postFormGroup
      .get('title')
      .setValidators([Validators.required, Validators.maxLength(60)]);

    this.clearPollFieldValidators();
    this.clearAnswerControls();
  }

  private usePoll(): void {
    this.postFormGroup.get('body').setValidators(null);
    this.postFormGroup.get('body').clearAsyncValidators();
    this.postFormGroup.get('articleBody').setValidators(null);
    this.postFormGroup.get('articleBody').clearAsyncValidators();
    this.postFormGroup.get('title').setValidators(null);

    this.postFormGroup.get('dayDuration').setValue(0);
    this.postFormGroup.get('hourDuration').setValue(0);
    this.postFormGroup.get('minuteDuration').setValue(30);

    this.setFieldPollValidators();
    this.addMandatoryAnswers();
  }

  private clearPollFieldValidators(): void {
    this.postFormGroup.get('question').setValidators(null);

    this.postFormGroup.get('dayDuration').setValidators(null);
    this.postFormGroup.get('hourDuration').setValidators(null);
    this.postFormGroup.get('minuteDuration').setValidators(null);

    this.postFormGroup.clearValidators();
  }

  private setFieldPollValidators(): void {
    this.postFormGroup
      .get('question')
      .setValidators(
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(200)
        ])
      );

    this.postFormGroup.get('dayDuration').setValidators(Validators.required);
    this.postFormGroup.get('hourDuration').setValidators(Validators.required);
    this.postFormGroup.get('minuteDuration').setValidators(Validators.required);
  }

  private addMandatoryAnswers(): void {
    // just two
    this.answers.push(new FormControl('', Validators.required));
    this.answers.push(new FormControl('', Validators.required));
  }

  private clearAnswerControls(): void {
    this.answers.clear();
  }

  ngOnDestroy() {
    this.unsubscribed$.next();
    this.unsubscribed$.complete();
    // Default to normal post when one navigates away
    this.createPost();
  }
}
